import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

interface IDescriptionProps {
    isSubscribed: boolean;
    unSubscribedLabel: string;
    subscribedLabel: string;
    userEmail: string;
}

export const Description = ({ isSubscribed, subscribedLabel, unSubscribedLabel, userEmail }: IDescriptionProps) => {
    return (
        <>
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[400]}
            >
                {isSubscribed ? unSubscribedLabel : subscribedLabel}
            </Text>
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[400]}
            >
                <strong>{userEmail}</strong>
            </Text>
        </>
    );
};
